import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[darkShadow]'
})
export class DarkShadowDirective {

    private readonly hoverShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -2px rgba(0, 0, 0, 0.15)';

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    @HostListener('mouseenter')
    onMouseEnter() {
        this.renderer.setStyle(this.el.nativeElement, 'box-shadow', this.hoverShadow);
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.renderer.removeStyle(this.el.nativeElement, 'box-shadow');
    }
}
